import Vue from 'vue'

import { cloneDeep, get } from 'lodash'

import { OrderDirections } from '@sigmasms/shared-types'

import { components, proxy } from '@/utils'

import render from './render'

export default {
  name: components.table,

  mixins: [ proxy({ type: 'object' }) ],

  props: {
    cols: {
      type: Array,
      default: () => {
        return []
      }
    },
    headers: {
      type: Array,
      default: () => {
        return []
      }
    },

    hideHead: {
      type: Boolean,
      default: false
    },
    hideFoot: {
      type: Boolean,
      default: false
    },

    items: {
      type: Array,
      default: () => {
        return []
      }
    },

    sortLocal: {
      type: Boolean,
      default: false
    },

    sortType: {
      type: String,
      default: 'string',
      validator: value => {
        return !!~[ 'string', 'number' ].indexOf(value)
      }
    },

    dense: {
      type: Boolean,
      default: false
    },
    tiny: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    computedItems() {
      if (this.sortLocal) {
        const array = cloneDeep(this.items)
        array.sort((a, b) => {
          let result = 0

          Object.keys(this.proxy).some(key => {
            const aValue = get(a, key)
            const bValue = get(b, key)

            let direction = 0

            if (aValue > bValue) {
              direction = 1
            } else if (aValue < bValue) {
              direction = -1
            }

            if (this.proxy[key].toLowerCase() === 'asc') {
              direction *= -1
            }

            if (direction !== 0) {
              result = direction

              return true
            }
          })

          return result
        })

        return array
      }

      return this.items
    },

    hasCols() {
      return Array.isArray(this.cols) && this.cols.length > 0
    },
    hasBody() {
      return Array.isArray(this.computedItems) && this.computedItems.length > 0
    },
    hasHead() {
      return Array.isArray(this.headers) && this.headers.length > 0 && !this.hideHead && this.hasBody
    },
    hasFoot() {
      return this.$slots.foot && !this.hideFoot && this.hasBody
    }
  },

  methods: {
    sorting(value, sortable) {
      if (sortable) {
        switch (this.proxy[value]) {
          case OrderDirections.ASC: {
            let descValue = -1
            if (this.sortType === 'string') {
              descValue = OrderDirections.DESC
            }
            Vue.set(this.proxy, value, descValue)
            break
          }
          case OrderDirections.DESC:
            Vue.delete(this.proxy, value)
            break
          default: {
            let ascValue = 1
            if (this.sortType === 'string') {
              ascValue = OrderDirections.ASC
            }
            Vue.set(this.proxy, value, ascValue)
            break
          }
        }
      }
    }
  },

  render
}
